var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result",class:{'done': _vm.done && !_vm.favorite, 'favorite': _vm.favorite},on:{"click":_vm.gotoRecipe}},[(_vm.favorite)?_c('fa',{attrs:{"icon":"star"}}):(_vm.done)?_c('fa',{attrs:{"icon":"check"}}):_vm._e(),_c('div',{staticClass:"image",style:({
      backgroundImage: `url(${_vm.imageUrl(_vm.recipe.ImageUrl)})`,
      backgroundPosition: _vm.focalPosition
    })}),_c('tags',{attrs:{"list":_vm.getUniqueRecipeCategories(_vm.recipe.Categories)}}),_c('h6',[_vm._v(_vm._s(_vm.recipe.Title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }